import React, { Component } from "react";
import Table from '../../../../../components/table';
import { connect } from "react-redux";
// import queryString from 'query-string';
import {
    ACTIONS_PLAYER, getPlayerConditionPitcher, convertPlayerConditionPitcher,
    convertPlayerConditionPitcher2,
    convertPlayerConditionPitcherCommon
} from '../../../../../actions/player-condition-pitcher';
import Loading from "../../../../../components/loading";
import moment from 'moment';

class PitcherContent extends Component {

    constructor(props) {

        super(props);
        this.state = {
            dataPitcherTable1: [],
            dataPitcherTable2: [],
            dataPitcherTable3: [],
            dataPitcherTable4: [],
            dataPitcherTable5: [],
            dataPitcherTable6: [],
            dataPitcherTable7: [],
            dataPitcherTable8: [],
            dataPitcherTable9: [],
            showLoading: false,
            centralLeague: [],
            pacificLeague: []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.response) {
            if (nextProps.status === ACTIONS_PLAYER.GET_PLAYER_CONDITION_PITCHER_SUCCESS) {
                this.setState({
                    showLoading: false,
                    dataPitcherTable1: convertPlayerConditionPitcher(nextProps.response.central_league),
                    centralLeague: nextProps.response.central_league,
                    dataPitcherTable2: convertPlayerConditionPitcher(nextProps.response.pacific_league),
                    pacificLeague: nextProps.response.pacific_league,
                    dataPitcherTable3: convertPlayerConditionPitcher(nextProps.response.monthly),
                    dataPitcherTable4: convertPlayerConditionPitcher2(nextProps.response['right.left']),
                    dataPitcherTable5: convertPlayerConditionPitcher(nextProps.response.stadium),
                    dataPitcherTable6:  convertPlayerConditionPitcherCommon(nextProps.response['count']),
                    dataPitcherTable7:  convertPlayerConditionPitcherCommon(nextProps.response['runners_on']),
                    dataPitcherTable8: convertPlayerConditionPitcherCommon(nextProps.response['scene.innings']),
                    dataPitcherTable9: convertPlayerConditionPitcherCommon(nextProps.response['scene.top_of_inning']),
                })
            }
        }

        if (this.props.tab && nextProps.tab === 'pitcher' && (this.props.tab !== 'pitcher' || nextProps.date_from !== this.props.date_from || nextProps.date_to !== this.props.date_to)) {
            this.setState({showLoading: true});
            this.props.getPlayerConditionPitcher(nextProps.id, moment(nextProps.date_from).format('YYYY/MM/DD'), moment(nextProps.date_to).format('YYYY/MM/DD'));
        }
    }

    redirectToOpponentTeam(id) {
        this.props.history.push(`/team-report/${id}`);
    }

    render() {
        return (
            <div>
                <Table header={this.props.headerPitcherTable1} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable1} isShowOptionTable={false} titleTable={this.props.titlePitcherTable1} onRowClick={(data, index) => {this.redirectToOpponentTeam(this.state.centralLeague[index].opponent_team_id)}} />
                <Table header={this.props.headerPitcherTable2} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable2} isShowOptionTable={false} titleTable={this.props.titlePitcherTable2} onRowClick={(data, index) => {this.redirectToOpponentTeam(this.state.pacificLeague[index].opponent_team_id)}} />
                <Table header={this.props.headerPitcherTable3} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable3} isShowOptionTable={false} titleTable={this.props.titlePitcherTable3} />
                <Table header={this.props.headerPitcherTable4} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable4} isShowOptionTable={false} titleTable={this.props.titlePitcherTable4} />
                <Table header={this.props.headerPitcherTable6} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable6} isShowOptionTable={false} titleTable={this.props.titlePitcherTable6} />
                <Table header={this.props.headerPitcherTable7} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable7} isShowOptionTable={false} titleTable={this.props.titlePitcherTable7} />
                <Table header={this.props.headerPitcherTable8} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable8} isShowOptionTable={false} titleTable={this.props.titlePitcherTable8} />
                <Table header={this.props.headerPitcherTable9} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable9} isShowOptionTable={false} titleTable={this.props.titlePitcherTable9} />
                <Table header={this.props.headerPitcherTable5} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataPitcherTable5} isShowOptionTable={false} titleTable={this.props.titlePitcherTable5} />
                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}

const mapStateToProps = ({ pitcherContent }) => {
    return {
        headerPitcherTable1: pitcherContent.headerPitcherTable1,
        headerPitcherTable2: pitcherContent.headerPitcherTable2,
        headerPitcherTable3: pitcherContent.headerPitcherTable3,
        headerPitcherTable4: pitcherContent.headerPitcherTable4,
        headerPitcherTable5: pitcherContent.headerPitcherTable5,
        headerPitcherTable6: pitcherContent.headerPitcherTable6,
        headerPitcherTable7: pitcherContent.headerPitcherTable7,
        headerPitcherTable8: pitcherContent.headerPitcherTable8,
        headerPitcherTable9: pitcherContent.headerPitcherTable9,
        titlePitcherTable1: pitcherContent.titlePitcherTable1,
        titlePitcherTable2: pitcherContent.titlePitcherTable2,
        titlePitcherTable3: pitcherContent.titlePitcherTable3,
        titlePitcherTable4: pitcherContent.titlePitcherTable4,
        titlePitcherTable5: pitcherContent.titlePitcherTable5,
        titlePitcherTable6: pitcherContent.titlePitcherTable6,
        titlePitcherTable7: pitcherContent.titlePitcherTable7,
        titlePitcherTable8: pitcherContent.titlePitcherTable8,
        titlePitcherTable9: pitcherContent.titlePitcherTable9,
        dataPitcherTable1: pitcherContent.dataPitcherTable1,
        dataPitcherTable2: pitcherContent.dataPitcherTable2,
        dataPitcherTable3: pitcherContent.dataPitcherTable3,
        dataPitcherTable4: pitcherContent.dataPitcherTable4,
        dataPitcherTable5: pitcherContent.dataPitcherTable5,
        response: pitcherContent.response,
        status: pitcherContent.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getPlayerConditionPitcher: (playerId, datePickerFrom, datePickerTo) => {
            dispatch(getPlayerConditionPitcher(playerId, datePickerFrom, datePickerTo));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PitcherContent);